module.exports = __webpack_public_path__ + "static/media/boyBands2.948cffd0.jpg";